// extracted by mini-css-extract-plugin
export default {"wrapper":"people_wrapper__kEYhz","name":"people_name__91o-E"};